export const LISTER_DOCUMENTS = 'document/LISTER_DOCUMENTS';
export const UPLAOD_DOCUMENTS = 'document/UPLAOD_DOCUMENTS';
export const UPLAOD_LOGO = 'document/UPLAOD_LOGO';
export const SUPPRIMER_DOCUMENTS = 'document/SUPPRIMER_DOCUMENTS';
